<template>
    <div
      class="by-dataset-details-container d-flex flex-column bg-transparent site-wrapper"
      :data-cy="getRepresentativeLocaleOf(getTitle, $route.query.locale, getLanguages)
      && `dataset@${getRepresentativeLocaleOf(getTitle, $route.query.locale, getLanguages)}`"
    >
    <!-- Navigation not wanted from bayern -->
    <!-- <dataset-details-navigation v-if="topTitle" :dataset-id="getID"/> -->
    <div class="by-dataset-details-content-container container-fluid mb-5 pt-1 content dsd-content">
        <dataset-details-header :previous-route="previousRoute"/>
        <!-- <dataset-details-navigation v-if="!topTitle" :dataset-id="getID"/> -->
        <router-view name="datasetDetailsSubpages"></router-view>
    </div>
  </div>
</template>

  <script>
  import { mapGetters } from 'vuex';
  import DatasetDetailsHeader from "./datasetDetails/DatasetDetailsHeader.vue";
  import { DatasetDetailsNavigation, helpers, head } from "@piveau/piveau-hub-ui-modules";
  const { getRepresentativeLocaleOf, getTranslationFor } = helpers;
  import { useCatalogId } from '../composables/useCatalogId';
  import { useStore } from "vuex";
  import { useHead } from '@unhead/vue';
  import { computed } from 'vue';

  export default {
    name: 'datasetDetails',
    components: {
      DatasetDetailsHeader,
      DatasetDetailsNavigation,
    },
    data() {
      return {
        topTitle: this.$env.content.datasetDetails.header.navigation === "top",
        previousRoute: null,
      };
    },
    props: {
      activeTab: {
        type: Number,
        default: 0
      },
      citationStyle: String
    },
    computed: {
      ...mapGetters('datasetDetails', [
        'getID',
        'getLanguages',
        'getTitle',
        'getDescription',
      ]),
    },
    methods: {
      getRepresentativeLocaleOf,
      getTranslationFor,
    },
    created () {
      console.log('back', this.$router.options.history.state)
      this.previousRoute = this.$router.options.history.state?.back;
    },
    setup() {
      const store = useStore();
      const catalogId = useCatalogId();
      head.useDatasetDetailsHead();

      const raw = computed(() => store.getters['datasetDetails/getRaw']);

      const normalizePresenceId = (value) => {
        if (!value || typeof value !== 'string') return null;
        return value.replace(/\.bydata$/i, '');
      };

      const allowedCatalogIds = computed(() => {
        const presence = raw.value?.open_data_presence;
        if (!Array.isArray(presence)) return [];
        return presence
          .map((p) => normalizePresenceId(p?.id))
          .filter(Boolean);
      });

      const currentCatalogId = computed(() => normalizePresenceId(catalogId.value));

      const shouldNoIndex = computed(() => {
        const current = currentCatalogId.value;
        if (!current) return false;
        return !allowedCatalogIds.value.includes(current);
      });

      useHead(() => {
        if (!shouldNoIndex.value) return {};
        return {
          meta: [
            {
              name: 'robots',
              content: 'noindex, nofollow',
              tagPriority: 'critical',
            },
          ],
        };
      });
    }
  };
  </script>

<style lang="scss">
  .site-wrapper.by-dataset-details-container {
    padding: 32px 32px 0 !important;
    margin: 0 !important;
  }

  @media screen and (min-width: 1200px) {
    .site-wrapper.by-dataset-details-container {
      padding: 32px 80px 0 !important;
    }
  }
</style>
